import React, { useEffect, useState } from 'react';
import { Button, TextField } from '@radix-ui/themes';
import { call } from 'api';
import { errorToastMessage } from 'helpers/toaster';
import { useDebounce } from 'helpers/useDebounceHook';
import type { PlayerSearchForMergeType } from 'types/player';
import PlayerUserObject from './PlayerUserObject';

export const SearchablePlayerForMatch: React.FC<{
  player: PlayerSearchForMergeType;
  onChangePlayerHandler: (player: PlayerSearchForMergeType | null) => void;
  label: string;
}> = ({ player, onChangePlayerHandler, label }) => {
  const [input, setInput] = useState('');
  const [playerResults, setPlayerResults] = useState<PlayerSearchForMergeType[] | undefined>();
  const debouncedSearchTerm = useDebounce(input, 500);

  useEffect(() => {
    const setResults = () => {
      call(
        `fit-player-profiles/search-for-merge/${debouncedSearchTerm}`,
        { method: 'GET' },
        (data) => {
          setPlayerResults(data);
        },
        (error) => {
          errorToastMessage(JSON.stringify(error));
        },
      );
    };
    if (debouncedSearchTerm) {
      setResults();
    }
  }, [debouncedSearchTerm]);

  const renderPlayersResults = () =>
    playerResults?.map((playerResult: PlayerSearchForMergeType) => (
      <div
        onClick={() => {
          setInput('');
          setPlayerResults(undefined);
          onChangePlayerHandler(playerResult);
        }}
      >
        <PlayerUserObject type='fit_player_profile' {...playerResult} linkToPlayer={false} key={playerResult.id} />
      </div>
    ));

  const renderNoResults = () => <p>Nessun giocatore corrispondente al criterio di ricerca</p>;

  const renderResults = () => (
    <div className=''>
      {playerResults?.length === 0 && input.length !== 0 ? renderNoResults() : renderPlayersResults()}
    </div>
  );

  const renderPlayer = () => (
    <div className=''>
      <p>
        <strong style={{ marginRight: '5px' }}>Giocatore selezionato</strong>
        <Button onClick={() => onChangePlayerHandler(null)}>Togli</Button>
      </p>
      <p>
        <strong>ID:</strong> {player.id}
      </p>
      <p>
        <strong>Nome:</strong> {player.name}
      </p>
      <p>
        <strong>Classifica:</strong> {player.rank}
      </p>
      <p>
        <strong>Tessera:</strong> {player.card_number}
      </p>
      <p>
        <strong>Codice Angrafica:</strong> {player.anagrafica_code}
      </p>
    </div>
  );

  const renderInput = () => (
    <div>
      <TextField.Root
        type='text'
        value={input}
        onChange={(e) => {
          setInput(e.target.value);
        }}
      />
      {playerResults ? renderResults() : null}
    </div>
  );

  return (
    <div className=''>
      <label>{label}</label>
      {player ? renderPlayer() : renderInput()}
    </div>
  );
};

export default SearchablePlayerForMatch;
